import genNewRichText from './genNewRichText';
const getUpdatedSrc = (currentRichTextImageAsDomElement, currentRichTextImage, defaultImage, src) => {
  const newValue = src || defaultImage;
  return genNewRichText(currentRichTextImageAsDomElement, currentRichTextImage, 'src', newValue);
};
export default getUpdatedSrc;